<template lang="pug">
    div
        SectionHeader(title="Socio-demographics")
        div.settings-section
            switchItem.section-item(
                label="Behavioral dimension"
                type="sociodemo" 
                inputName="behavioral" 
                :isDisabled="processing"
                :isSwitchActive="socioDemoSettings.behavioral"
                @change="onSocioDemoSettingChange($event, 'behavioral', 'Behavioral')"
                )
            switchItem.section-item(
                label="Demographic dimension" 
                type="sociodemo" 
                inputName="demographic" 
                :isDisabled="processing"
                :isSwitchActive="socioDemoSettings.demographic"
                @change="onSocioDemoSettingChange($event, 'demographic', 'Demographic')"
            )
            switchItem.section-item(
                label="Geographic dimension"
                type="sociodemo"
                inputName="geography"
                :isDisabled="processing"
                :isSwitchActive="socioDemoSettings.geography"
                @change="onSocioDemoSettingChange($event, 'geography', 'Geographic')"
            )
            switchItem.section-item(
                label="Technologic dimension"
                type="sociodemo"
                inputName="technology"
                :isDisabled="processing"
                :isSwitchActive="socioDemoSettings.technology"
                @change="onSocioDemoSettingChange($event, 'technology', 'Technologic')"
            )
</template>
<script>
import SectionHeader from '@/components/common/SectionHeader'
import SwitchItem from '@/components/common/SwitchItem'
import { mapState, mapActions } from 'vuex'
import { API_SOCIODEMO_SETTINGS } from '@/utils/constants'

export default {
    components: { SectionHeader, SwitchItem },

    data() {
        return {
            processing: false,
        }
    },

    computed: {
        ...mapState('data/settings', {
            socioDemoSettings: state => state.sociodemo,
        }),
        ...mapState('ui/settings', {
            uiSocioDemoSettings: state => state.sociodemo,
        })
    },

    methods: {
        ...mapActions('data/settings', [
            'updateSettings',
        ]),

        onSocioDemoSettingChange(value, settingLabel, label) {
            this.launchUpdateSetting({
                type: 'sociodemo',
                value,
                settingLabel,
                notificationLabel: label + ' dimension',
                settingsMapper: API_SOCIODEMO_SETTINGS
            })
        },

        launchUpdateSetting({ type, value, settingLabel, notificationLabel, settingsMapper, callback, params }) {
            this.processing = true
            if (!params) {
                params = {}
                const settingKey = settingsMapper[settingLabel]
                params[settingKey] = this.setsApiData(value)
            }

            this.updateSettings({ params, type, notificationLabel, settingLabel }).then(() => {
                if (callback) callback()
                this.processing = false
            })
        },

       
        setsApiData(data) {
            return data ? 'YES' : 'NO'
        },
    }
}
</script>
